// src/components/store/sections/gallery/GalleryV30CathedralwindowsIndigoPulse.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV30CathedralwindowsIndigoPulse(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={30}
      archKey="cathedral_windows"
      archLabel="Cathedral Arch Windows"
      palName="IndigoPulse"
      grad="from-indigo-500 via-blue-600 to-violet-700"
      lightBg="bg-indigo-50"
      textCol="text-indigo-700"
      borderCol="border-indigo-200"
      btnCls="bg-indigo-600 hover:bg-indigo-700"
      hexCol="#6366f1"
      {...props}
    />
  );
}
